var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-10 0 80 80",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-.468.582h241.376v117.496h-241.376z",
    fill: "#fff",
    transform: "matrix(.248575 0 0 .0678962 .116218 71.9829)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-6.076-2.722-1.814-1.979-5.608-4.569 1.303-1.45 3.562-3.133 1.568 6.633 14.487z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 34.57860865 23.5819593584)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-12.067.996 5.3-1.372 6.767-2.47-1.386.707-5.82-.163 1.764-2.297-.571 1.938-4.311z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 38.0220980116 41.812725756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-2.15-6.539h8.493l-.938 5.725-8.198-1.061z",
    fill: "#fff",
    transform: "matrix(-.06131216798 .44510775856 .44510775856 .06131216798 31.3796929328 69.798771708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-9.715.595 9.727h4.035l.669-1.897-1.191-7.842z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 31.6982082692 72.32623318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-9.484-14.377h29.823l-.687 3.052-32.908.875z",
    fill: "#fff",
    transform: "matrix(.06169390523 .44505469036 .44505469036 -.06169390523 41.946066856 27.4127404436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-45.243.171 45.208 4.108.035 5.261-45.243",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 31.6215070308 67.955536228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-62.05 1.1 18.616-2.185 43.434h-4.709l-1.865-43.22z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 31.2041433272 68.440579576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 22.275.964-22.275 2.822 3.932-.6 15.958",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 25.7445576688 21.2531144696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-66.347 5.476-2.259 2.185 5.381 7.732.224 2.601-4.796 4.984 3.422-3.347 4.422-.415 18.626 6.922 43.362-28.665.224 6.616-43.106-1.261-21.485z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 26.1942222168 51.041285736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 14.485-1.88-14.366-6.691-3.285.008-.116-6.563 4.081-1.279 13.367 1.678 3.12 12.468.481z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 35.1697530192 11.4365942124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-27.007-9.598h41.465l-4.233-28.352-39.257 12.386z",
    fill: "#fff",
    transform: "matrix(.06980591028 .44385534904 .44385534904 -.06980591028 41.1900219 44.868392712)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-16.469 2.641h16.469l-.48-2.641h-15.509z",
    fill: "#fff",
    transform: "matrix(-.44931076 0 0 .44931076 27.7700647264 33.119800808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 15.254h3.268l3.52-4.525-.629-9.681-6.278-1.048-3.902 1.552.126 9.177z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 30.8933405692 12.5655317204)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-12.784-7.9 11.658 1.679 1.126 9.119-11.816",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 25.874008698 35.499025108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5.91 1.996h3.293l1.449-4.638-1.454-.349-2.626 3.077",
    fill: "#fff",
    transform: "matrix(-.35864550924 .27065489576 .27065489576 .35864550924 20.4188100108 36.38314132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(.20093778627 -.40187486496 -.40187486496 -.20093778627 21.02145249 36.423119364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-55.3h7.9v55.3z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 10.372787478 72.216912688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-55.3 7.9 55.3h-7.9z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 10.372787478 72.216912688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-55.3h7.9v55.3z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 45.868160624 72.216912688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-55.3 7.9 55.3h-7.9z",
    fill: "#fff",
    transform: "matrix(.44931076 0 0 .44931076 45.868160624 72.216912688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.184-9.249h8.832l-7.066 14.131-5.299-7.066z",
    fill: "#fff",
    transform: "matrix(-.24499465212 .48998930424 .48998930424 .24499465212 29.3810737632 41.140528556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533-1.063-.475-3.565 7.002z",
    fill: "#fff",
    transform: "matrix(.26531977272 -.53063954544 -.53063954544 -.26531977272 19.92105505996 44.2836519056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(.26531977272 -.53063954544 -.53063954544 -.26531977272 16.45043015876 44.2836519056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(.20093778627 -.40187486496 -.40187486496 -.20093778627 14.53714465476 45.3053916496)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(.25637459693 -.51274848628 -.51274848628 -.25637459693 17.36886380676 45.4171886576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(.25637459693 -.51274848628 -.51274848628 -.25637459693 21.29576909156 45.4171886576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533-1.063-.475-3.565 7.002z",
    fill: "#fff",
    transform: "matrix(-.26531977272 -.53063954544 .53063954544 -.26531977272 34.6197718838 44.65332852468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(-.26531977272 -.53063954544 .53063954544 -.26531977272 38.090396785 44.65332852468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(-.20093778627 -.40187486496 .40187486496 -.20093778627 40.003682289 45.67506826868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(-.25637459693 -.51274848628 .51274848628 -.25637459693 37.171963137 45.78686527668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(-.25637459693 -.51274848628 .51274848628 -.25637459693 33.2450578522 45.78686527668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533-1.063-.475-3.565 7.002z",
    fill: "#fff",
    transform: "matrix(-.26531977272 -.53063954544 .53063954544 -.26531977272 38.2043518998 44.65332852468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(-.26531977272 -.53063954544 .53063954544 -.26531977272 41.674976801 44.65332852468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(-.20093778627 -.40187486496 .40187486496 -.20093778627 43.588262305 45.67506826868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(-.25637459693 -.51274848628 .51274848628 -.25637459693 40.756543153 45.78686527668)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.417 4.625h4.416l1.767-3.533-2.65-3.533z",
    fill: "#fff",
    transform: "matrix(-.25637459693 -.51274848628 .51274848628 -.25637459693 36.8296378682 45.78686527668)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1106 462.405h94.8v7.9h-94.8z",
    fill: "#fff",
    transform: "matrix(-.44931076 0 0 .44931076 548.13107816 -163.942945496)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.de0ec0270f3d786195f19e7963834836.svg";
export { ForwardRef as ReactComponent };